import { createContext, useContext } from 'react';
const PREFIX_ICON = 'pplx-icon-';
const CONTEXT_DEFAULTS = {
    src: ({ id }) => `#${PREFIX_ICON}${id}`,
    version: '0',
    defaultSize: 20, // Tabler base size
};
export const IconSpriteContext = createContext(CONTEXT_DEFAULTS);
export const useIconSpriteContext = () => {
    const context = useContext(IconSpriteContext);
    return context;
};
//# sourceMappingURL=IconSpriteContext.js.map